import { Controller } from "@hotwired/stimulus"
import Redactor from "../../assets/javascripts/redactor/redactor.min.js";

export default class extends Controller {
  connect() {
    Redactor(this.element, {
      buttons: ['bold', 'italic', 'underline', 'lists', 'link'],
      minHeight: '200px'
    });
  }
}
